import { Box, FormControl, InputLabel, MenuItem, Select, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import 'react-quill/dist/quill.snow.css';
import { MerChantModel } from "../../models/merChantModel";
import { TEXT_TITLE_COLOR } from "../../constants/colors";
import { PromotionEnumType } from "../../enums/promotionEnum";
import useFormPromotionController from "./controller/form";
import BuyXGetXFormComponent from './form/buyXgetX'
import BuyXGetYFormComponent from "./form/buyXgetY";
import BuyXGetDsFormComponent from "./form/buyXgetDs";
import BuyXUGetSppFormComponent from "./form/buy-x-u-get-spp";
import BuyXSetUGetCBDFormComponent from "./form/buy-x-set-u-get-cbd";
import BuyXSetAGetCBPFormComponent from "./form/buy-x-set-a-get-cbp";
import BuyXSetAGetRDFormComponent from "./form/buy-x-set-a-get-rd";
import { TagPromotionModel } from "../../models/tagPromotion.model";
import BuyXGetSetAGetCSTByPriceFormComponent from "./form/buy-x-set-a-get-cst-by-price";
import BuyXGetSetAGetCSTByUnitFormComponent from "./form/buy-x-set-a-get-cst-by-unit";
import { PromotionModel } from "../../models/promotion";

// import BuyXGetYFormComponent from "./form/buyXgetY";
interface Props {
    onClose: VoidFunction
    onFetchData: Function
    selectPromotionType: PromotionEnumType
    branchValue: string
    branchData: MerChantModel[]
    tagPromotionData: TagPromotionModel[]
    selectedData: PromotionModel
}

const FormComponent = ({ onClose, onFetchData, selectPromotionType, branchValue, branchData, tagPromotionData, selectedData }: Props) => {
    const controller = useFormPromotionController({ onClose, onFetchData, selectPromotionType, branchValue, branchData, selectedData })
    const { t } = useTranslation("global")

    const useRenderForm = () => {
        switch (controller.promotionType) {
            case PromotionEnumType.buy_x_get_x:
                return <BuyXGetXFormComponent
                    onClose={onClose}
                    branchData={branchData}
                    tagPromotionData={tagPromotionData}
                    promotionType={controller.promotionType}
                    onFetchData={onFetchData}
                    selectedData={selectedData}
                />
            case PromotionEnumType.buy_x_get_y:
                return <BuyXGetYFormComponent
                    onClose={onClose} branchData={branchData}
                    tagPromotionData={tagPromotionData}
                    promotionType={controller.promotionType}
                    onFetchData={onFetchData}
                    selectedData={selectedData}
                />
            case PromotionEnumType.buy_x_get_ds:
                return <BuyXGetDsFormComponent
                    onClose={onClose}
                    branchData={branchData}
                    tagPromotionData={tagPromotionData}
                    promotionType={controller.promotionType}
                    onFetchData={onFetchData}
                    selectedData={selectedData}
                />
            case PromotionEnumType.buy_x_u_get_spp:
                return <BuyXUGetSppFormComponent
                    onClose={onClose}
                    branchData={branchData}
                    tagPromotionData={tagPromotionData}
                    promotionType={controller.promotionType}
                    onFetchData={onFetchData}
                    selectedData={selectedData}
                />
            case PromotionEnumType.buy_x_set_u_get_cbd:
                return <BuyXSetUGetCBDFormComponent
                    onClose={onClose}
                    branchData={branchData}
                    tagPromotionData={tagPromotionData}
                    promotionType={controller.promotionType}
                    onFetchData={onFetchData}
                    selectedData={selectedData}
                />
            case PromotionEnumType.buy_x_set_a_get_cbp:
                return <BuyXSetAGetCBPFormComponent
                    onClose={onClose}
                    branchData={branchData}
                    tagPromotionData={tagPromotionData}
                    promotionType={controller.promotionType}
                    onFetchData={onFetchData}
                    selectedData={selectedData}
                />
            case PromotionEnumType.buy_x_set_a_get_rd:
                return <BuyXSetAGetRDFormComponent
                    onClose={onClose}
                    branchData={branchData}
                    tagPromotionData={tagPromotionData}
                    promotionType={controller.promotionType}
                    onFetchData={onFetchData}
                    selectedData={selectedData}
                />
            case PromotionEnumType.buy_x_set_a_get_cst_by_price:
                return <BuyXGetSetAGetCSTByPriceFormComponent
                    onClose={onClose}
                    branchData={branchData}
                    tagPromotionData={tagPromotionData}
                    promotionType={controller.promotionType}
                    onFetchData={onFetchData}
                    selectedData={selectedData}
                />
            case PromotionEnumType.buy_x_set_u_get_cst_by_unit:
                return <BuyXGetSetAGetCSTByUnitFormComponent
                    onClose={onClose}
                    branchData={branchData}
                    tagPromotionData={tagPromotionData}
                    promotionType={controller.promotionType}
                    onFetchData={onFetchData}
                    selectedData={selectedData}
                />
            default:
                return null;
        }
    }

    return (
        <form onSubmit={(e) => controller.handleOpenConfirmForm(e)}>
            <Box>
                <Typography variant="h4" mb={2} fontWeight="bold" color={TEXT_TITLE_COLOR}>{t("promotion_page.Create Promotion")}</Typography>
                <Typography color={TEXT_TITLE_COLOR}>{t("promotion_page.Promotion type")} : <span style={{ color: '#11A2F1' }}>{t("promotion_page." + controller.promotionType)}</span></Typography>
            </Box>
            <Box sx={{ width: 250 }} mt={3}>
                <FormControl fullWidth size="small">
                    <InputLabel id="promotion-label-id" shrink={true}>{t("promotion_page.Promotion type")}</InputLabel>
                    <Select
                        labelId="promotion-label-id"
                        id="promotion-id"
                        label="promotion Type"
                        value={controller.promotionType}
                        onChange={controller.handleSelectPromotionType}
                    // sx={{ bgcolor: SELECT_BACKGROUND_COLOR, '.MuiOutlinedInput-notchedOutline': { border: 0 }, borderRadius: '8px' }}
                    >
                        {
                            Object.values(PromotionEnumType).map((type: PromotionEnumType) => (
                                <MenuItem key={type} value={type}>
                                    {t("promotion_page." + type)}
                                </MenuItem>
                            ))
                        }
                    </Select>
                </FormControl>
            </Box>

            <Box>
                {useRenderForm()}
            </Box>

        </form>
    )
}
export default FormComponent; 